<template>
  <div height="100%" class="welcome" :style="{ backgroundImage: cImage() }" >
    <Login v-if="!loggedIn" id="login"/>
    <ChangePassword v-if="loggedIn && changePWDialog"/>
    </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import Login from './Login'
import ChangePassword from "../../coreui/components/ChangePassword"
export default {
  components: {
    Login,
    ChangePassword
  },
  data: () => ({
    // image: require("../assets/background.jpg")
  }),
  computed: {
    loggedIn: sync('login/loggedIn'),
    loginDialog: sync('login/loginDialog'),
    changePWDialog: sync('login/changePWDialog'),
    image: sync('login/loginWelcomeBackground')
  },
  methods: {
    cImage() {
      var now = new Date()
      var hours = now.getHours()
      if (hours > 5 && hours <= 7) {
        return `linear-gradient(to bottom, rgba(63, 60, 235, 0.7), rgba(166, 154, 218, 0.8)),url(${this.image})`
      } else if (hours > 7 && hours <= 16) {
        return `url(${this.image})`
      } else if (hours > 16 && hours < 20) {
        return `linear-gradient(to bottom, rgba(63, 60, 235, 0.7), rgba(166, 154, 218, 0.8)),url(${this.image})`
      } else {
        return `linear-gradient(to bottom, rgba(63, 60, 235, 0.7), rgba(166, 154, 218, 0.8)),url(${this.image})`
      }
    }
  },
  mounted () {
    if (!localStorage.getItem('loggedIn')) {
      this.loggedIn = false
      this.loginDialog = true
    }
    console.log('logged in status, loginDialog: ', this.loggedIn, this.loginDialog)
  }
}
</script>

<style scoped>
@import "../styles/basic.css";
</style>
